import type Subjects from '@lved/ui/components/shared/ui/Tabs/Subjects';
import { ReactWidget } from '@theia/core/lib/browser';
import { injectable, postConstruct } from '@theia/core/shared/inversify';

type SubjectsModule = { Subjects: typeof Subjects };

@injectable()
export class SubjectsPanel extends ReactWidget {
    static readonly ID: string = 'widget:lvgl-subjects';
    static readonly LABEL: string = 'Subjects';

    protected module: SubjectsModule | undefined;
    protected loadError: string | undefined;

    @postConstruct()
    protected init(): void {
        this.doInit();
    }

    protected async doInit(): Promise<void> {
        this.id = SubjectsPanel.ID;
        this.title.label = SubjectsPanel.LABEL;
        this.title.caption = SubjectsPanel.LABEL;
        this.title.closable = true;
        await this.loadModule();
        this.update();
    }

    protected async loadModule(): Promise<void> {
        try {
            this.module = (await import('@lved/ui')) as unknown as SubjectsModule;
        } catch (error: unknown) {
            this.loadError = error instanceof Error ? error.message : 'Failed to load Subjects panel.';
        }
    }

    protected render(): JSX.Element {
        if (this.loadError) return <p>{this.loadError}</p>;
        if (!this.module) return <p>Loading Subjects...</p>;
        const { Subjects } = this.module;
        return <Subjects />;
    }
}
